import _ from 'lodash';

export const isUploading = (state) => ! _.isEmpty(
    _.filter(state.uploads, upload => upload.percentage < 100 && upload.state !== 'error')
);

export const getThumbnail = (state, width, height) => {
    return _.find(state.thumbnails, thumbnail => {
        return thumbnail.width === width && thumbnail.height === height
    });
}

export const getThumbnailUrl = (state, width, height) => {
    const thumbnail = getThumbnail(state, width, height);

    return thumbnail ? thumbnail.url : state.filename;
};

export const findByIds = (state, ids) => (
    _.pickBy(state.media, media => ids.includes(media.id))
);
